/**
 * 语言控制
 */
import { restaurantCenter } from 'restaurant'
import { thirdConfigG } from 'controllers/third'

class LanguageController {
  /** 修改语言 */
  static languageLabel = {
    'zh-CN': '简体中文',
    'en-US': 'English',
    'de-DE': 'Deutsch'
  }
  /**
   * 切换系统语言
   * language zh-CN | en-US | de-DE
   * reload 是否刷新页面 默认ture
  */
  static changeLanguage (language: TLanguage, reload: boolean = true) {
    i18n.changeLanguage(language)
    restaurantCenter.setConfig({ language })
    Config.i18n = language
    thirdConfigG()?.postMessage({
      type: 'setLanguage',
      language: language
    })
    if (reload) {
      location?.reload()
    }
  }
}

export default LanguageController
